import React from 'react';

const UserMinus = ({ color = 'white', ...rest }) => {
  return (
    <svg {...rest} xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
      <circle cx="10.2487" cy="5.8737" r="3.41667" stroke={color} strokeWidth="1.28125" />
      <path
        d="M12.8138 12.1349C12.0225 11.9547 11.1575 11.8555 10.2513 11.8555C6.47736 11.8555 3.41797 13.5764 3.41797 15.6992C3.41797 17.8221 3.41797 19.543 10.2513 19.543C15.1093 19.543 16.5136 18.6732 16.9196 17.4076"
        stroke={color}
        strokeWidth="1.28125"
      />
      <circle cx="15.3737" cy="14.4167" r="3.41667" stroke={color} strokeWidth="1.28125" />
      <path
        d="M14.5195 14.418H16.2279"
        stroke={color}
        strokeWidth="1.28125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default React.forwardRef(UserMinus);
